import { get, post } from '@/apis/http';
import { appCode } from "@/utils/IMEI";
import { apiPath, mdApiPath, apsApi, serviceApi } from '@/config';
import  request  from '@/utils/request'
// 获取公共配置
export function queryConfigValue (data) {
  return post(apiPath + '/common/getJfConfigurationValue', data)
}

// 获取广告图片
export function queryBrandImgList (data) {
  return post(apiPath + '/common/brandLineAndImageList', data)
}

// 获取App渠道链接
export function queryChannelInfo(code = 'N9999') {
  return get(apiPath + '/common/getChannelInfo', {}, {
    headers : {
      appcode: code
    }
  })
}
export function getTodayData(data) {
  return post(apiPath + '/common/getRate', data)
}
export function outGoldRateLogs(data) {
  return get(apiPath + '/common/outGoldRateLogs', data)
}

// 首冲活动假数据
export function getFakebonus(data) {
  return get(apiPath + '/common/getFakebonus', data)
}
//CRM埋点 ------------------------------begian
export function getHashParams(type) {
  var result = {};
  var params = (window.location.hash.split('?')[1] || '').split('&');
  var paramParts = [];
  for (var param in params) {
    if (params.hasOwnProperty(param)) {
      paramParts = params[param].split('=');
      result[paramParts[0]] = decodeURIComponent(paramParts[1] || "");
    }
  }
  if (type) {
    return result[type];
  }
  return result;
}

// CRM埋点
export function maidianOpenreal(data) {
  const paramsMd = appCode()

  if (getHashParams('clientid')) {
    localStorage.setItem('clientid', getHashParams('clientid'))
    var clientid = localStorage.getItem('clientid')
  } else if (localStorage.getItem('clientid')) {
    clientid = localStorage.getItem('clientid')
  } else {
    clientid = (Math.random() * 10000000).toString(16).substr(0, 4) + '_' + (new Date()).getTime() + '_' + Math.random().toString().substr(2, 5);
    localStorage.setItem('clientid', clientid)
  }
  return post(
    mdApiPath,
    [
      {
        sourceid: 1,
        usertype: 1,
        clientid: clientid,
        eventtime: new Date().getTime(),
        detail: {
          ...data.detail,
          channelname: '手动输入',
          backurl: data.backurl || document.referrer,
          currenturl: data.currenturl || window.location.href,
          account: data.account || '',
          accounttype: data.accounttype || '',
          medium: paramsMd['utm_medium'] || undefined, //媒介
          keyworld: paramsMd['utm_term'] || undefined, //关键字
          plan: paramsMd['utm_campaign'] || undefined, //计划
          unit: paramsMd['utm_content'] || undefined, //单元
          packageid: paramsMd['channel'] || paramsMd['v'] || undefined,
        },
        eventname: data.eventname,
        eventdescribe: data.eventdescribe,
        eventtype: data.eventType || 'other',
      }
    ],
  )
}



//获取伦敦金、伦敦银比例数
export function datacenterGoldSilverScale(data) {
  return post(apiPath + '/common/GetGSrPosForPm', data)
}

/// 获取实时交易数
export function GetRealTimeOrder(data) {
  return post(apiPath + '/common/GetRealTimeOrderListForPm', data)
}
// 获取多空比例数
export function queryGoldSilverComman(data) {
  return post(apiPath + '/common/GetGSCommandPosForPm', data)
}


//获取伦敦金、伦敦银比例数
export function queryGetGoldSilver(data) {
  return post(apiPath + '/common/GetGSrPosForPm', data)
}

// 邮件Common/ecallbak
export function queryEmailCallback(data) {
  return get(apsApi + '/Common/ecallbak', data)
}

// 财经日历
export function ViewListWithHoliday(data) {
  return post(serviceApi + '/api/services/app/EconomicCalendar/ViewListWithHoliday', data, {
    headers: {
      'Content-Type': 'application/json',
      'language': 'cn'
    }
  })
}



